/* 劉曄（字子揚） */
import { SG, gd, landing, spMul } from '../../core/kit.ts';
import { defineHero, hook, P } from '../define.ts';

export default defineHero({
  id: 'liuye', name: '劉曄', sub: '字子揚', faction: 'wei', role: '輔助', weapon: 'staff',
  look: { head: 'guan', robe: true, beard: 'goatee', fx: '#d8a860', c: { cloth: '#4a5a3a', sleeve: '#4a5a3a', pole: '#5a4028' } },
  skills: [
    ['發石', 'thunder', '朝地點拋出巨石，1 秒後落下，範圍 {72/112/152/192} 傷害並暈眩 0.75 秒。', { x: { k: 'aoe', dmg: [72, 112, 152, 192], r: 110, delay: 1, cc: { stun: 0.75 }, fx: 'slam', ground: true }, aim: P(700, 110), cd: 10, mp: [70, 80, 90, 100], el: 'earth' }],
    ['破樓櫓', 'trap', '標記一塊區域 8 秒：區域內敵方建築與召喚物受到的傷害 +{15/22/30/38}%，我方小兵攻速 +30%。', { x: { k: 'breach', r: 260, dur: 8, amp: [15, 22, 30, 38] }, aim: P(600, 260), cd: [24, 22, 20, 18], mp: 90, el: 'earth' }],
    ['料事', 'passive', '每 {20/17/14/11} 秒自動看穿一名 1200 內躲在迷霧、草叢或隱身的敵將 3 秒。', { pv: {}, sig: 'foresee', every: [20, 17, 14, 11] }],
    ['霹靂車', 'summon', '在指定地點架起霹靂車 {15/20/25} 秒（不能移動，生命 {600/900/1200}），每 2 秒朝 750 內的敵人或建築拋石，造成 {90/135/185} 範圍傷害，對建築加倍、對小兵減半。', { x: { k: 'catapult', dur: [15, 20, 25], hp: [600, 900, 1200], dmg: [90, 135, 185], range: 750, r: 110 }, aim: P(400, 60), cd: [90, 80, 70], mp: [150, 175, 200], el: 'earth', shout: '霹靂車，發！' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    breach(u, a, X) {
      this.zone(u, { x: a.pt[0], y: a.pt[1], r: X.r, t: X.dur, tick: 9, ground: true, name: a.sk.name, x2: { breach: X.amp } });
      this.fx({ k: 'slam', x: a.pt[0], y: a.pt[1], col: '#d8a860' });
    },
    catapult(u, a, X) {
      this.units.forEach((o) => { if (o.alive && o.pili && o.owner === u) { o.alive = false; o.deadT = this.t; this.fx({ k: 'puff', x: o.x, y: o.y }); } });
      const p = landing(u.x, u.y, a.pt[0], a.pt[1]);
      const s = this.spawnMinion(u.team, null, p[0], p[1], true);
      Object.assign(s, { temp: X.dur, owner: u, summon: true, still: true, ms: 0, ranged: true, range: X.range, siege: 'catapult', bldMul: 2, maxHp: X.hp, hp: X.hp,
        atk: X.dmg * spMul(u), asp: 62.5, armor: 6, r: 30, name: '霹靂車', pili: { r: X.r } });
      this.fx({ k: 'slam', x: p[0], y: p[1], col: '#d8a860' });
    },
  },
  methods: {
    // 霹靂車拋石：飛到目標當下的位置才落地爆開
    piliShot(u, t) {
      const dir = SG.dirTo(u, t.x, t.y), r = u.pili.r;
      const pr = this.shootProj(u, { dir, speed: 560, range: Math.max(40, gd(u.x, u.y, t.x, t.y) - 30), shape: 'rock', el: 'earth' });
      pr.onEnd = () => {
        this.enemiesNear(u, pr.x, pr.y, r).forEach((o) => this.damage(u, o, u.atk, { magic: true, spell: true, stagger: 0.3 }));
        this.fx({ k: 'slam', x: pr.x, y: pr.y, col: '#d8a860' });
      };
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 破樓櫓：區域內的建築、召喚物多受傷害
    hook('damage.before', 30, function (c) {
      const t = c.t;
      if ((t.structure || t.summon) && this.zones.length) {
        let amp = 0;
        for (const z of this.zones) if (z.x2 && z.x2.breach && z.team !== t.team && gd(z.x, z.y, t.x, t.y) <= z.r + t.r) amp = Math.max(amp, z.x2.breach);
        c.a *= 1 + amp / 100;
      }
    }),
    // 霹靂車：普攻改成拋石
    hook('attack', 60, function (u, a, next) { const t = a.target; if (u.pili) { if (t && t.alive) this.piliShot(u, t); return; } return next(); }),
    // 破樓櫓：區域內的己方小兵加攻速
    hook('zone', 50, function (z, dt) { const e = z.x2; if (e.breach) for (const t of this.units) if (t.alive && t.kind === 'minion' && t.team === z.team && gd(z.x, z.y, t.x, t.y) <= z.r) this.addBuff(t, { id: 'breach', t: 0.6, as: 30 }); }),
    // 料事：定時看穿附近躲起來的敵將
    hook('step.hero', 20, function (u, dt) {
      const fs = u.sg && u.sg.foresee;
      if (fs && (u.foreT = (u.foreT == null ? 3 : u.foreT) - dt) <= 0) {
        const t = this.units.filter((o) => o.kind === 'hero' && o.alive && o.team === 1 - u.team && !o.vis[u.team] && gd(u.x, u.y, o.x, o.y) < 1200).sort((p, q) => gd(u.x, u.y, p.x, p.y) - gd(u.x, u.y, q.x, q.y))[0];
        if (t) { this.expose(t, u.team, 3); u.foreT = fs.v('every'); this.tell(u, `料事：看穿 ${t.name}`, 'info'); this.fx({ k: 'warn', x: t.x, y: t.y, r: 50, t: 1 }); }
        else u.foreT = 1;
      }
    }),
  ],
  // 電腦什麼時候放這招
  ai: {
    breach: ({ w, u, t, d, hero, hpR, foeHeroes }) => !!t && !!t.structure && d < 700,
    catapult: ({ w, u, t, d, hero, hpR, foeHeroes }) => !!t && (!!t.structure || hero) && d < 800,
  },
});
